import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import customTheme from "config/theme";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    modalPaper: {
      backgroundColor: "#fff",
      boxShadow: theme.shadows[5],
      borderRadius: 8,
      width: 620,
      padding: 24,
      [theme.breakpoints.down("sm")]: {
        width: "86%",
        padding: 12,
      },
      margin: "auto",
      position: "relative",
    },
    avatarModalPaper: {
      maxHeight: 630,
      display: "flex",
      flexDirection: "column",
    },
    avatarModalHeader: {
      flexShrink: 0,
      fontSize: 20,
      fontWeight: 600,
      marginBottom: 20,
    },
    avatarModalContent: {
      overflowY: "auto",
      overflowX: "hidden",
      flex: 1,
      minHeight: 0,
      marginRight: -10,
      paddingRight: 24,
    },
    previewContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: 30,
      marginTop: 10,
    },
    modalActions: {
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(2),
      marginTop: 16,
      paddingTop: 12,
      borderTop: "1px solid #eee",
      backgroundColor: theme.palette.background.paper,
    },
    defaultAvatarsContainer: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(62px, 1fr))",
      gap: 15,
      [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: "repeat(auto-fit, minmax(60px, 1fr))",
      },
      margin: 10,
    },
    defaultAvatar: {
      width: 62,
      height: 62,
      borderRadius: "50%",
      cursor: "pointer",
      border: `2px solid ${(customTheme as any).bgButton}`,
      transition: "all 0.2s",
      "&:hover": {
        borderColor: (customTheme as any).bgButton,
        transform: "scale(1.1)",
      },
    },
    iconButtonAvatar: {
      width: 62,
      height: 62,
      border: `2px solid ${(customTheme as any).bgButton}`,
      cursor: "pointer",
      backgroundColor: "#fff",
      transition: "all 0.2s",
      "&:hover": {
        transform: "scale(1.1)",
      },
    },
    saveButton: {
      backgroundColor: (customTheme as any).bgButton,
      color: "white",
      "&:hover": {
        backgroundColor: "#5a36d5",
      },
    },
    modalTitle: {
      fontSize: 20,
      fontWeight: 600,
      marginBottom: theme.spacing(2),
    },
    cameraPreview: {
      width: "100%",
      maxWidth: 400,
      margin: "0 auto",
      marginBottom: theme.spacing(2),
      borderRadius: 8,
      overflow: "hidden",
      backgroundColor: "#000",
      position: "relative",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    webcamElement: {
      width: "100%",
      height: "auto",
      display: "block",
      transform: "scaleX(-1)", // Mirror the video for better UX
    },
    capturedImage: {
      width: "100%",
      maxWidth: 400,
      height: "auto",
      borderRadius: 8,
      objectFit: "contain",
    },
    locationModalPaper: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(3),
      borderRadius: 8,
      outline: "none",
      maxWidth: 500,
      width: "90%",
      margin: "auto",
      position: "relative",
      [theme.breakpoints.down("sm")]: {
        width: "95%",
        padding: theme.spacing(2),
      },
    },
    locationModalTitleContainer: {
      display: "flex",
      alignItems: "center",
    },
  })
);

export default useStyles;

